import { graphql } from 'react-relay';

export default graphql`
  query TrinityLogin_Query {
    viewer {
      id
      ...TrinityLogin_viewer
    }
  }
`;
